export default function StatsSection() {
  const stats = [
    { value: '200+', label: '服务品牌', icon: 'ri-building-2-line' },
    { value: '5000+', label: '达人资源', icon: 'ri-user-star-line' },
    { value: '10亿+', label: '内容曝光', icon: 'ri-eye-line' },
    { value: '50+', label: '专业团队', icon: 'ri-team-line' },
  ];

  return (
    <section className="w-full py-14 md:py-20 bg-primary-500" aria-label="数据统计">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 max-w-5xl mx-auto">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-white/15 text-white mb-3">
                <i className={`${stat.icon} text-xl`} />
              </div>
              <p className="text-3xl md:text-4xl font-bold font-heading text-white mb-1">
                {stat.value}
              </p>
              <p className="text-sm text-white/80">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}